import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { usePartnerAuth } from '../contexts/PartnerAuthContext';

interface ProtectedPartnerRouteProps {
  children: React.ReactNode;
  requiredRole?: string;
  redirectTo?: string;
}

/**
 * Component that protects partner routes based on authentication and role requirements
 */
const ProtectedPartnerRoute: React.FC<ProtectedPartnerRouteProps> = ({ 
  children, 
  requiredRole, 
  redirectTo = '/partner/login' 
}) => {
  const { isAuthenticated, hasRole, isLoading } = usePartnerAuth();
  const location = useLocation();

  // Show loading while checking authentication
  if (isLoading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '200px' 
      }}>
        <div>Loading...</div>
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to={redirectTo} state={{ from: location }} replace />;
  }

  // Check role requirement
  if (requiredRole && !hasRole(requiredRole)) {
    // Show access denied
    return (
      <div style={{ 
        padding: '2rem', 
        textAlign: 'center',
        backgroundColor: '#fff',
        margin: '2rem',
        borderRadius: '8px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
      }}>
        <h2 style={{ color: '#e74c3c', marginBottom: '1rem' }}>Access Denied</h2>
        <p>You don't have permission to access this page.</p>
        <p>Required role: <strong>{requiredRole}</strong></p>
      </div>
    );
  }

  return <>{children}</>;
};

export default ProtectedPartnerRoute;

